


import {LinearProgress} from "@mui/material";
import React, {useEffect, useState} from "react";
import {getSplash} from "../../services/services";



const ContactBoxTwo = () => {
    const [data,setData] = useState(false)

    const getdata = async ()=>{

        const res = await getSplash()
        if (res){

            setData(res.data)
        }
    }

    useEffect(() => {
        getdata().then()



    }, []);



    let content

    if (data) {
        content = <div className="columns p-6">
            <div className="column is-12-mobile is-4-desktop my-6">
                        <span className="is-flex is-align-items-center is-justify-content-center">
                            <span className="info" >
                                <img src="/icons/call.png" />
                            </span>
                            <h3 className="mr-3">شماره تماس</h3>
                        </span>
                <div className="contact__number my-2 has-text-centered">

                    {
                        data !== false ? <a style={{color: 'inherit'}}
                                            href={`tel:${data.options.phone}`}>{data.options.phone}</a> : "..."
                    }

                </div>
            </div>
            <div className="column is-12-mobile is-4-desktop my-6">
                    <span className="is-flex is-align-items-center is-justify-content-center">
                        <span className="info " >
                                <img src="/icons/location.png" alt='location' />
                            </span>
                            <h3 className="mr-3">آدرس</h3>
                        </span>
                <div className="contact__number my-2">
                    {
                        data !== false ? <a target={'_blank'} style={{color: 'inherit'}}
                                            href={`https://www.google.com/maps/@${data.options.lat},${data.options.lng},15z?entry=ttu}`}>{data.options.address} </a> : "..."
                    }
                </div>
            </div>
            <div className="column is-12-mobile is-4-desktop my-6">
                    <span className="is-flex is-align-items-center is-justify-content-center">
                        <span className="info " >
                                <img src="/icons/telegram.png" />
                            </span>
                            <h3 className="mr-3">شبکه های اجتماعی</h3>
                        </span>
                <span className="contact__socials mt-5">

                            <a href={data.options.telegram}><img src="/icons/telegram.png" width={35}/></a>
                            <a href={data.options.instagram}><img src="/icons/instagram.png" width={35}/></a>
                            <a href={data.options.whatsapp}><img src="/icons/whatsapp.png" width={35}/></a>
                        </span>
            </div>
        </div>
    }



    return (
        <>
            <div className="contact__info shadowtwo p-6 mt-3" >
                {
                    content
                }
            </div>



      </>


  )
}
export default ContactBoxTwo;